module.exports = __webpack_public_path__ + "media/images/city/011-torii-gate-bf37a066dadaf033f0afa380272be938.svg";